module.exports = __webpack_public_path__ + "img/Logo_Pollen_bleu.2d2955e9.png";